"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isMethodAllowedForModel = exports.methodsForModel = exports.supportsRpc = exports.modelFamilyOf = exports.GATEWAY_MODEL_FAMILIES = exports.GATEWAY_MODELS = void 0;
// Which gateway models serve which RPC methods; a model number not listed here allows nothing, as every Develco hub (MGW*) has no RPC.
const registry_js_1 = require("./methods/registry.js");
exports.GATEWAY_MODELS = {
    'pi-duck': {
        // Written verbatim by flasher_new/lib/flash-pi.ts.
        modelNumbers: ['Pi-Duck 01'],
        methods: [
            'gateway.info', 'gateway.setDebug', 'gateway.uploadLogs', 'gateway.sshTunnel', 'gateway.logStream',
            'zigbee.listDevices', 'zigbee.getDevice', 'zigbee.getState', 'zigbee.permitJoin', 'zigbee.read',
            'zigbee.set', 'zigbee.write', 'zigbee.command', 'zigbee.getCluster',
        ],
    },
};
exports.GATEWAY_MODEL_FAMILIES = Object.keys(exports.GATEWAY_MODELS);
// Exact and case-sensitive, as stored; searched as arrays, so an untrusted '__proto__' has no inherited key to hit.
const modelFamilyOf = (modelNumber) => {
    if (typeof modelNumber !== 'string')
        return null;
    for (const family of exports.GATEWAY_MODEL_FAMILIES) {
        const modelNumbers = exports.GATEWAY_MODELS[family].modelNumbers;
        if (modelNumbers.indexOf(modelNumber) !== -1)
            return family;
    }
    return null;
};
exports.modelFamilyOf = modelFamilyOf;
const supportsRpc = (modelNumber) => (0, exports.modelFamilyOf)(modelNumber) !== null;
exports.supportsRpc = supportsRpc;
// A copy, so a caller cannot widen a family by pushing onto what it was handed.
const methodsForModel = (modelNumber) => {
    const family = (0, exports.modelFamilyOf)(modelNumber);
    return family === null ? [] : exports.GATEWAY_MODELS[family].methods.slice();
};
exports.methodsForModel = methodsForModel;
// The method name is untrusted too, so it must be a contract method before the family's list is searched.
const isMethodAllowedForModel = (modelNumber, method) => {
    const family = (0, exports.modelFamilyOf)(modelNumber);
    if (family === null || !(0, registry_js_1.isRpcMethodName)(method))
        return false;
    const methods = exports.GATEWAY_MODELS[family].methods;
    return methods.indexOf(method) !== -1;
};
exports.isMethodAllowedForModel = isMethodAllowedForModel;
